// TODO: please refactor and make use of the QuantityInput component
import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FieldContext } from '../'
import { requiredValidationErrorMessage } from '../../utils'
import FormFieldRegistrationManager from '../../FormFieldRegistrationManager'

class OTPInput extends React.Component {
  state = {
    digits: ['', '', '', '', '', '']
  }

  handleDigitChange = (index, value) => {
    if (value.length > 1) {
      value = value.slice(-1)
    }

    const newDigits = [...this.state.digits]
    newDigits[index] = value

    this.setState({ digits: newDigits })

    const fullOTP = newDigits.join('')

    if (this.fieldContext) {
      this.fieldContext.handleOnChange(fullOTP)
    }

    if (typeof this.props.onValueChange === 'function') {
      this.props.onValueChange(fullOTP)
    }

    if (value && index < 5) {
      const nextInput = this.inputRefs[index + 1]
      if (nextInput) {
        nextInput.focus()
      }
    }
  }

  handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !this.state.digits[index] && index > 0) {
      const prevInput = this.inputRefs[index - 1]
      if (prevInput) {
        prevInput.focus()
      }
    }
  }

  handlePaste = (e) => {
    e.preventDefault()
    const pastedData = e.clipboardData.getData('text').slice(0, 6)

    if (/^\d+$/.test(pastedData)) {
      const digits = pastedData.split('').concat(['', '', '', '', '', '']).slice(0, 6)
      this.setState({ digits })

      const fullOTP = digits.join('')

      if (this.fieldContext) {
        this.fieldContext.handleOnChange(fullOTP)
      }

      if (typeof this.props.onValueChange === 'function') {
        this.props.onValueChange(fullOTP)
      }

      const nextEmptyIndex = digits.findIndex(digit => digit === '')
      const focusIndex = nextEmptyIndex === -1 ? 5 : nextEmptyIndex
      if (this.inputRefs[focusIndex]) {
        this.inputRefs[focusIndex].focus()
      }
    }
  }

  componentDidMount () {
    if (this.inputRefs[0]) {
      this.inputRefs[0].focus()
    }
  }

  inputRefs = []

  render () {
    const {
      required,
      validate,
      defaultValue,
      disabled,
      hasError,
      ...otherProps
    } = this.props

    const { digits } = this.state

    return (
      <FieldContext.Consumer>
        {(field) => {
          this.fieldContext = field
          return (
            <FormFieldRegistrationManager
              register={() => {
                field.register({
                  required,
                  validate,
                  requiredValidator: async (value) => {
                    if (!value || value.length !== 6) {
                      return required && requiredValidationErrorMessage(required)
                    }
                  },
                  value: defaultValue || '',
                  ...otherProps
                })
              }}
              deregister={() => field.deregister()}
            >
              <div className='vs-u-row vs-u-gap-half vs-u-justify-center'>
                {digits.map((digit, index) => (
                  <input
                    key={index}
                    ref={(ref) => { this.inputRefs[index] = ref }}
                    type='text'
                    inputMode='numeric'
                    pattern='[0-9]*'
                    maxLength='1'
                    value={digit}
                    className={classnames(
                      'vs-form-field__input',
                      'vs-text-input',
                      'vs-form-otp-input',
                      {'vs-text-input--has-error': field.hasErrors() || hasError}
                    )}
                    disabled={disabled}
                    onChange={(e) => this.handleDigitChange(index, e.target.value)}
                    onKeyDown={(e) => this.handleKeyDown(index, e)}
                    onPaste={index === 0 ? this.handlePaste : undefined}
                    autoComplete='one-time-code'
                  />
                ))}
              </div>
            </FormFieldRegistrationManager>
          )
        }}
      </FieldContext.Consumer>
    )
  }
}

OTPInput.propTypes = {
  required: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]),

  /**
   * A custom validation function
   */
  validate: PropTypes.func,

  /**
   * Runs when field value changes (returns full OTP code)
   */
  onValueChange: PropTypes.func,

  /**
   * Initial field value (6-digit OTP code)
   */
  defaultValue: PropTypes.string,

  /**
   * Whether the inputs are disabled
   */
  disabled: PropTypes.bool
}

OTPInput.defaultProps = {
  required: false,
  validate: undefined,
  defaultValue: '',
  disabled: false
}

OTPInput.displayName = 'Form.Field.OTPInput'

export default OTPInput
